document.addEventListener('DOMContentLoaded', () => {
    // Знаходимо кнопки в твоїй розмітці
    const googleButtons = document.querySelectorAll('.login__button--google');
    const appleButtons = document.querySelectorAll('.login__button--apple');

    if (!googleButtons.length && !appleButtons.length) {
        return; // На сторінці немає потрібних кнопок – нічого не робимо
    }

    // Обчислюємо домен магазину (як у bitLogin-скрипті)
    let host = window.location.host;
    if (host === 'admin.shopify.com') {
        const parts = window.location.pathname.split('/');
        if (parts[2]) {
            host = `${parts[2]}.myshopify.com`;
        }
    }

    const bitLoginBaseUrl = 'https://api.bitbybit.studio';
    const apiUrl = `${bitLoginBaseUrl}/bitlogin/api`;

    /**
     * Універсальний виклик social login.
     * 1) Якщо існує глобальний onClickSocialLogin — використовуємо його (повна логіка bitLogin).
     * 2) Якщо ні — відкриваємо вікно логіну напряму через /bitlogin/api/login/{provider}.
     */
    const triggerBitlogin = (provider) => {
        // 1. Якщо bitLogin-extension уже підключений і дав нам метод
        if (typeof window.onClickSocialLogin === 'function') {
            window.onClickSocialLogin({ provider, host });
            return;
        }

        // 2. Фолбек: відкриваємо вікно авторизації напряму
        const rand = Math.random().toString();

        // Параметри вікна
        const width = 800;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2 - 50;

        const url =
            `${apiUrl}/login/${encodeURIComponent(provider)}` +
            `?referrerId=${encodeURIComponent(rand)}` +
            `&shop=${encodeURIComponent(host)}`;

        window.open(
            url,
            'bitlogin_window',
            `menubar=1,resizable=1,width=${width},height=${height},top=${top},left=${left}`,
        );
    };

    // Прив'язуємо до Google-кнопок
    googleButtons.forEach((btn) => {
        btn.addEventListener('click', (event) => {
            event.preventDefault();
            triggerBitlogin('google');
        });
    });

    // Прив'язуємо до Apple-кнопок
    appleButtons.forEach((btn) => {
        btn.addEventListener('click', (event) => {
            event.preventDefault();
            triggerBitlogin('apple');
        });
    });
});
